import { NoPayoutRationale } from 'src/entities/basic-types/NoPayoutRationale/NoPayoutRationale';
import { PartnerNoPayoutRationaleRequest } from 'src/entities/basic-types/NoPayoutRationale/PartnerNoPayoutRationale';
import callApi, { CallApiResult, getCustomerId } from '.';

/* NoPayoutRationales */
export const getNoPayoutRationales = (): Promise<CallApiResult> => {
    const endpoint = '/api/admin/noPayout/list';
    return callApi(endpoint);
};

export const addNoPayoutRationale = (noPayoutRationale: NoPayoutRationale) => {
    const endpoint = '/api/admin/noPayout/add';
    return callApi(endpoint, { method: 'POST', data: noPayoutRationale });
};

export const updateNoPayoutRationale = (noPayoutRationale: NoPayoutRationale): Promise<CallApiResult> => {
    const endpoint = '/api/admin/noPayout/update';
    return callApi(endpoint, { method: 'PUT', data: noPayoutRationale });
};

export const deleteNoPayoutRationale = (noPayoutRationaleId: number): Promise<CallApiResult> => {
    const endpoint = `/api/admin/noPayout/${noPayoutRationaleId}/delete`;
    return callApi(endpoint, { method: 'DELETE' });
};

/* PartnerNoPayoutRationales */
export const getPartnerNoPayoutRationales = (): Promise<CallApiResult> => {
    const partnerid = getCustomerId();
    const endpoint = `/api/admin/noPayout/partner/list?partnerId=${partnerid}`;
    return callApi(endpoint);
};

export const addPartnerNoPayoutRationale = (
    partnerNoPayoutRationale: PartnerNoPayoutRationaleRequest
): Promise<CallApiResult> => {
    const endpoint = '/api/admin/noPayout/partner/add';
    return callApi(endpoint, { method: 'POST', data: partnerNoPayoutRationale });
};

export const deletePartnerNoPayoutRationale = (partnerNoPayoutRationaleId: number): Promise<CallApiResult> => {
    const endPoint = `/api/admin/noPayout/partner/${partnerNoPayoutRationaleId}/delete`;
    return callApi(endPoint, { method: 'DELETE' });
};
